import logo from './logo.svg';
import './TsstMain.css';
import React, { useState } from 'react';

// bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import { getQuestionList } from './questionList';

//function App() {
class TsstMain extends React.Component {
  TIMEOUT = 45;
  MAX_QUESTION = 3;
  questionList;

  constructor(props) {
    super(props);
    this.questionList = getQuestionList();
    this.state = {
      timerCount: 0,
      questionCount: 0,
      startButtonValid: true,
      startButtonStr: "開始",
      questionStr: "問題文がここに表示されます",
      questionStrEn: ""
    };
  }

  // 問題を開始
  startQuestion = () => {
    let questionCount = this.state.questionCount + 1;
    let questionStr = this.getNextQuestion();

    // レンダリング
    this.setState({
      timerCount: -1,
      startButtonValid: false,
      startButtonStr: "次へ",
      questionStr: questionStr[0],
      questionStrEn: questionStr[1],
      questionCount: questionCount
    });

    // 問題の読み上げ
    this.readQuestionJp(questionStr);
  }

  // 45秒のカウントを開始
  startCountDown = (questionStr) => {
    let currentCount = this.TIMEOUT;
    this.setState({
      timerCount: currentCount
    });

    const timerId = setInterval(
      () => {
        currentCount = currentCount - 1;
        this.setState({ timerCount: currentCount });
        if (currentCount <= 0) {
          clearInterval(timerId);
          this.setState({ startButtonValid: true });
        }
      }, 1000);
  }

  // 日本語の読み上げ
  readQuestionJp = (questionStr) => {
    // 日本語の読み上げ
    var speak = new SpeechSynthesisUtterance();
    speak.text = questionStr[0];
    speak.rate = 1.5; // 読み上げ速度 0.1-10 初期値:1 (倍速なら2, 半分の倍速なら0.5, )
    speak.pitch = 1;　// 声の高さ 0-2 初期値:1(0で女性の声) 
    speak.lang = 'ja-JP'; //(日本語:ja-JP, アメリカ英語:en-US, イギリス英語:en-GB, 中国語:zh-CN, 韓国語:ko-KR)
    speak.onend = function (event) {
      this.readQuestionEn(questionStr); //英語の読み上げ
    }
    speak.onend = speak.onend.bind(this);
    speechSynthesis.speak(speak);
  }

  // 英語の読み上げ
  readQuestionEn = (questionStr) => {
    var speak = new SpeechSynthesisUtterance();
    speak.text = questionStr[1];
    speak.rate = 1.5; // 読み上げ速度 0.1-10 初期値:1 (倍速なら2, 半分の倍速なら0.5, )
    speak.pitch = 1;　// 声の高さ 0-2 初期値:1(0で女性の声) 
    speak.lang = 'ja-JP'; //(日本語:ja-JP, アメリカ英語:en-US, イギリス英語:en-GB, 中国語:zh-CN, 韓国語:ko-KR)
    speak.onend = function (event) {
      this.startCountDown(questionStr);
    }
    speak.onend = speak.onend.bind(this);
    speechSynthesis.speak(speak);
  }

  // 問題をランダムに取得する
  getNextQuestion = () => {
    // TODO: 問題リストの管理（サーバ＋キャッシュだけど、とりあえずはベタ）
    return this.questionList[Math.floor(Math.random() * this.questionList.length)]
  }

  render() {
    return (
      <Container>
        <div className="TsstMain" fluid="sm">
          <div className="current-question">{this.state.questionCount}　問目</div>
            {this.state.timerCount != "-1"
            ? <div className="timelimit">残り時間　{this.state.timerCount}　秒</div>
            : <div className="timelimit">問題読み込み中</div>
            }
          <div className="question">{this.state.questionStr}</div>
          <div className="start-button">
            <Button variant="primary" onClick={() => this.startQuestion()}
              disabled={!this.state.startButtonValid}>{this.state.startButtonStr}</Button>
          </div>
        </div>
      </Container>
    );
  }
}

export default TsstMain;
